import { ReactNode } from 'react';

import {
   TherapeuticGroupCreateCommand,
   TherapeuticGroupSimpleQuery,
} from '@dreryk/egabinet-group-session-frontend-api';

import { ActionEventInterceptor, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

import { GroupSessionsCreateFormBean, GroupSessionsCreateFormController } from '../GroupSessionsCreateForm.types';
import { translationKeys } from '../../translations';

type AppointmentCreateActionEventInterceptorProps = Readonly<
   Pick<GroupSessionsCreateFormController, 'handleSubmit'> & {
      children: ReactNode;
   }
>;

export const TherapeuticGroupCreateActionEventInterceptor = (
   props: AppointmentCreateActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: createTherapeuticGroup } = useCqrsCommand<void, GroupSessionsCreateFormBean>(
      (parameters) => {
         const command = new TherapeuticGroupCreateCommand();
         command.name = parameters.name!;
         command.minParticipants = parameters.maxParticipants!;
         command.maxParticipants = parameters.maxParticipants!;
         command.ageRestrictionEnabled = parameters.ageRestrictionEnabled;
         if (parameters.ageRestrictionEnabled) {
            command.minAge = Slot.of(parameters.minAge);
            command.maxAge = Slot.of(parameters.maxAge);
         }
         command.practitionerIds = parameters.practitioners.value.map((practitioner) => practitioner.id);
         command.receptionServiceId = Slot.emptyIfNull(parameters.receptionService?.id ?? null);
         command.medicalServiceId = Slot.emptyIfNull(parameters.medicalService?.id ?? null);
         command.note = Slot.emptyIfNull(parameters.note ?? null);
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(TherapeuticGroupSimpleQuery);
            dispatchSnackbarPositiveEvent(translationKeys.successfullyCreatedTherapeuticGroup);
         },
      }
   );

   return (
      <ActionEventInterceptor action={props.handleSubmit(createTherapeuticGroup)}>
         {props.children}
      </ActionEventInterceptor>
   );
};
